<template>
  <div :class="type == 1 ? 'iconsTop icons' : 'icons'" v-if="pages && pages.length > 0">
    <van-swipe :options="swiperOption">
      <van-swipe-item v-for="(page, index) of pages" :key="index">
        <div class="icon" v-for="item of page" :key="item.id">
          <div class="icon-img" @click.prevent="jumpPath(item.path)">
            <img class="img-content" :src="item.imgUrl" />
          </div>
          <p class="keywords">{{item.desc}}</p>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: "HomeIcons",
  props: {
    icon: Array,
    num: Number,
    type: Number
  },
  data() {
    return {
      swiperOption: {
        autoplay: false
      }
    };
  },
  methods: {
    jumpPath(path) {
      if (path=='ERP') {
        wx.miniProgram.navigateTo({
          url: '/pages/jump/jump?id=wxc19b458d710592e7&path=pages/main/main',

        })
      }else{
        this.$router.push({
          path: path
        });
      }
    }
  },
  computed: {
    pages() {
      const pages = [];
      this.icon.forEach((item, index) => {
        const page = Math.floor(index / this.num);
        if (!pages[page]) {
          pages[page] = [];
        }
        pages[page].push(item);
      });
      return pages;
    }
  }
};
</script>

<style lang="scss" scoped>
.iconsTop{
  height: px2rem(540);
  .van-swipe{
    height: px2rem(520)!important;
  }
}
.icons {
  .van-swipe {
    padding:0 px2rem(40);
    .icon {
      float: left;
      min-width: 22%;
      height: px2rem(240);
      padding-top: px2rem(25);
      text-align: center;
      .icon-img {
        width: px2rem(100);
        height: px2rem(100);
        display: inline-block;
        img {
          border-radius: 50%;
        }
        .img-content {
          width: px2rem(100);
          height: px2rem(100);
          background: 0;
        }
      }
      .keywords {
        margin: px2rem(20) 0;
        color: #fff;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: px2rem(28);
      }
    }
  }
}
</style>